import { useQuery, UseQueryOptions } from '@tanstack/react-query';

import { CommonFindResult } from '@app/infra-interfaces';
import { Axios } from '@app/web-components';

const URL = 'node-supplier-contract';
const CONTRACT_SUMMARY_ALL_QUERY_KEY = 'CONTRACT_ALL_QUERY_KEY';

export const contractKeys = {
  all: [CONTRACT_SUMMARY_ALL_QUERY_KEY] as const,
  lists: () => [...contractKeys.all, 'list'] as const,
  list: (filters: object) => [...contractKeys.lists(), filters] as const,
};

export const useGetContractSummary = <T>(
  options?: Omit<UseQueryOptions<CommonFindResult<T>>, 'queryKey' | 'queryFn'>,
) => {
  const axios = Axios.useAxiosApi();

  return useQuery<CommonFindResult<T>>({
    ...options,
    queryKey: contractKeys.lists(),
    queryFn: async () => {
      return await axios.get(`/${URL}/contract-changes`);
    },
  });
};
